import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChildren,
    QueryList,
    ElementRef,
    Renderer2,
    AfterViewInit,
    ViewChild,
    HostListener, OnChanges, SimpleChanges
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../_services/auth.service';
import {HttpClient} from '@angular/common/http';
import { AppFirestoreService } from 'src/app/_services/app-firestore.service';
// import { AngularDraggableModule } from 'angular2-draggable';
import {GalleryHtml, GalleryImage, GalleryYoutube, GalleryIframe, GalleryItem, GalleryDocument} from './models';
import {AngularFireStorage} from '@angular/fire/compat/storage';
// import { environment } from '../../../environments/environment';
import {User} from '../../_core/_interface/user';
import {slideRight, changeDivSize, anim} from 'src/app/animations';
import {DataService} from '../../_services/data.service';
// import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
    trigger,
    state,
    style,
    animate,
    transition,
    keyframes,
    query,
    group
} from '@angular/animations';
import {LocationStrategy} from '@angular/common';
import * as _ from "lodash";
import { environment } from 'src/environments/environment';

// Author: Eyad Mansour
declare var window: any;

export function isFullScreen(): boolean {
    const fsDoc = <any>document;

    return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
}

interface FsDocumentElement extends HTMLElement {
    msRequestFullscreen: () => void;
    mozRequestFullScreen: () => void;
    webkitRequestFullscreen: () => void;
}

// const left = [
//   query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
//   group([
//     query(':enter', [style({ transform: 'translateX(-100%)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
//       optional: true,
//     }),
//     query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(100%)' }))], {
//       optional: true,
//     }),
//   ]),
// ];

// const right = [
//   query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
//   group([
//     query(':enter', [style({ transform: 'translateX(100%)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
//       optional: true,
//     }),
//     query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(-100%)' }))], {
//       optional: true,
//     }),
//   ]),
// ];

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
    animations: [
        // trigger('changeDivSize', [
        //   transition(':increment', left),
        //   transition(':decrement', right),
        // ]),
        changeDivSize,
        slideRight,
        anim
    ],
})
export class GalleryComponent implements OnInit, OnChanges {

    companyId = '0';
    images: Array<GalleryImage> = [];
    youtubes: Array<GalleryYoutube> = [];
    htmls: Array<GalleryHtml> = [];
    iframes: Array<GalleryIframe> = [];
    documents: Array<GalleryDocument> = [];
    pdfs: Array<GalleryDocument> = [];
    intro: GalleryHtml = undefined;
    user: User;
    fullscreen = false;
    thisShowScrollThumbs: any;
    hasThumbs: number;
    draggble: any;
    resolution: any;
    unika: boolean = false;


    // filesBaseUrl = 'https://firebasestorage.googleapis.com/v0/b/sirical-test.appspot.com/o/';
    filesBaseUrl = `https://firebasestorage.googleapis.com/v0/b/${environment.firebase.storageBucket}/o/`;
    preview = {
        html: '',
        show: false,
        type: '',
        index: 0,
        showNext: true,
        showPrevious: false,
        path: '',
        title: ''
    };

    urldd: string;
    currentState = 'initial';

    @Input() galleryId = '0';
    @Input() section: string;
    @Input() showThumbs: boolean = true;
    @Input() autoPlay: boolean = false;
    @Input() resizeDrag: boolean = false;
    @Input() fullscreenTrigger: boolean = false;
    @Input() play: boolean = false;
    @Input() delay: number = 7000;
    @Input() checkIfItems?: boolean = false;
    @Input() type: string = '';


    noItems: boolean = false;
    isMobile: boolean = false;
    @Output() public isNoItems = new EventEmitter();
    projUid: string = '';
    illustrationOnly: boolean = false;
    illustrationOnlyNote: string = "";
    proportionsClass: string = "";
    // sanitizedSvg: SafeHtml;
    @ViewChild('scrollContainer') scrollContainer!: ElementRef;

    private isDragging = false;
    private startX = 0;
    private scrollLeft = 0;
    private targetScrollLeft = 0;
    private scrollSpeed = 5.5;
    private dampingFactor = 0.4; // For smooth scroll effect
    private dragThreshold = 5; // Distance in pixels to consider it a drag
    private clickedImageIndex: number | null = null;
    // Track starting positions for drag threshold
    private initialMouseX = 0;
    private initialMouseY = 0;
    showMosaicPreview: boolean = false;
    private scrollInterval: any;

    constructor(private route: ActivatedRoute, private auth: AuthService, private db: AppFirestoreService,
                private storage: AngularFireStorage, private router: Router, public dataService: DataService, private renderer: Renderer2
                //  private http: HttpClient, private sanitizer: DomSanitizer
    ) {
    }


    ngOnInit() {
        this.user = this.auth.currentUserValue;
        this.unika = this.dataService.wichDesign().unika;
        // this.http.get('https://firebasestorage.googleapis.com/v0/b/spirical-maps.appspot.com/o/5z97bOrCj4PGDryAzDOS%2FjxVgXwPQsU2cOwpfloordrawing%2F1724844535208_FLOOR_00%20copy.svg?alt=media', { responseType: 'text' })
        // .subscribe(svg => {
        //   this.sanitizedSvg = this.sanitizer.bypassSecurityTrustHtml(svg);
        // });
        //  this.auth.user.subscribe(user => this.user = user);

        this.route.params.subscribe(
                params => {
                    this.companyId = params['id'];
                    if (params.section && !this.router.url.includes('/galleryD')) {
                        this.section = params.section;
                    }

                    // let sec = params['section'];
                    // if (sec) {
                    //   this.section = sec;
                    // }
                    this.loadThumbs();
                }
        );

        this.autoPlayImage(this.play);
        this.resolution = window.innerWidth;

        // if(this.resolution < 1200){
        //   this.resizeDrag = false;
        // }
        if (this.type === 'mosaic' && this.screenResolutionDetecting() < 1200) {
            this.type = '';
        }

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.section && !changes.section.firstChange) {
            console.log('section', this.section);
            this.loadThumbs();
        }
    }
    ngAfterViewInit() {
        const container = this.scrollContainer.nativeElement;
        // container.addEventListener('mousedown', (e: MouseEvent) => this.onMouseDown(e));
        // this.animateScroll();
    }

    startScroll(direction: 'left' | 'right') {
        const container = this.scrollContainer.nativeElement;

        this.scrollInterval = setInterval(() => {
            container.scrollLeft += direction === 'left' ? -10 : 10;
        }, 30);
    }

    stopScroll() {
        clearInterval(this.scrollInterval);
    }

    onMouseDown(event: MouseEvent, index: number) {
        event.preventDefault();
        this.isDragging = true;
        this.startX = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
        this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;

        // Record initial mouse positions to calculate drag distance
        this.initialMouseX = event.pageX;
        this.initialMouseY = event.pageY;

        // Store the clicked image index
        this.clickedImageIndex = index;

        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('mouseup', this.onMouseUp);
    }

    onMouseMove = (event: MouseEvent) => {
        if (!this.isDragging) return;

        const container = this.scrollContainer.nativeElement;
        const x = event.pageX - container.offsetLeft;

        // Calculate drag distance with damping
        const walk = (x - this.startX) * this.scrollSpeed; // Raw drag distance
        const dampedWalk = walk * this.dampingFactor; // Apply damping factor

        // Smoothly adjust the scroll position
        container.scrollLeft = this.scrollLeft - dampedWalk;

        // Optional: Mosaic-specific damping
        // if (this.type === 'mosaic') {
        //   container.scrollLeft += (this.targetScrollLeft - container.scrollLeft) * this.dampingFactor;
        //   requestAnimationFrame(() => this.animateScroll());
        // }
    };


    onMouseUp = (event: MouseEvent) => {
        const container = this.scrollContainer.nativeElement;

        // Calculate the total distance moved
        const movedDistance = Math.sqrt(
                Math.pow(event.pageX - this.initialMouseX, 2) + Math.pow(event.pageY - this.initialMouseY, 2)
        );

        if (movedDistance < this.dragThreshold && this.clickedImageIndex !== null) {
            // If the movement was small, treat as a click and open the image preview
            this.showPreview(0, 'image', this.clickedImageIndex);
        } else if (movedDistance >= this.dragThreshold) {
            // If movement exceeds the threshold, apply damping effect
            const dragDirection = event.pageX > this.initialMouseX ? 1 : -1; // Positive for right, negative for left
            let inertiaSpeed = Math.abs(event.pageX - this.initialMouseX) / 10; // Initial speed proportional to drag distance
            const dampingFactor = 0.9; // Controls how quickly inertia slows down

            const inertiaScroll = () => {
                if (Math.abs(inertiaSpeed) > 0.5) {
                    container.scrollLeft -= inertiaSpeed * dragDirection; // Move in drag direction
                    inertiaSpeed *= dampingFactor; // Gradually reduce speed
                    requestAnimationFrame(inertiaScroll);
                }
            };

            requestAnimationFrame(inertiaScroll);
        }

        // Reset drag state
        this.isDragging = false;
        this.clickedImageIndex = null; // Reset clicked index
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('mouseup', this.onMouseUp);
    };


    @HostListener('wheel', ['$event'])
    onWheel(event: WheelEvent) {
        this.targetScrollLeft += event.deltaY * this.scrollSpeed;
        event.preventDefault();
    }

    animateScroll() {
        // if(this.type === 'mosaic'){

        //   const container = this.scrollContainer.nativeElement;
        //   container.scrollLeft += (this.targetScrollLeft - container.scrollLeft) * this.dampingFactor;
        //   requestAnimationFrame(() => this.animateScroll());
        // }
    }

    // Function to open a larger image on click
    openLargeImage(event: MouseEvent) {
        console.log("Opening large image...");
        // Implement the logic to open the large image here
    }

    // Method to check orientation and apply class to parent element
    checkImageOrientation(index: number, event: Event, parentElement: ElementRef) {
        const imageElement = event.target as HTMLImageElement;
        const isHorizontal = imageElement.naturalWidth > imageElement.naturalHeight;
        const square = imageElement.naturalWidth === imageElement.naturalHeight;
        // Add class to parent based on orientation
        if (isHorizontal) {
            this.renderer.addClass(parentElement, 'horizontal');
        } else if (square) {
            this.renderer.addClass(parentElement, 'square');
        } else {
            this.renderer.addClass(parentElement, 'vertical');
        }
        if ((index + 3) % 3 === 0) {
            this.renderer.addClass(parentElement, 'first');
        } else if ((index + 2) % 3 === 0) {
            this.renderer.addClass(parentElement, 'second');
        } else if ((index + 1) % 3 === 0) {
            this.renderer.addClass(parentElement, 'third');
        }


        console.log(`Image at index ${index} is ${isHorizontal ? 'horizontal' : 'vertical'}`);
    }

    // dragElement(event) {
    //   this.resolution = window.innerWidth;
    //   let elmnt = event.target;
    //   let resolution = window.innerWidth;
    //   var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    //   /* otherwise, move the DIV from anywhere inside the DIV:*/
    //   if (resolution < 1200) {
    //     elmnt.ontouchstart = dragMouseDown;
    //     elmnt.ontouchstart(event)
    //   } else {
    //     elmnt.onmousedown = dragMouseDown;
    //     elmnt.onmousedown(event);
    //   }
    //   function dragMouseDown(e) {
    //     e = e || window.event;
    //     e.preventDefault();
    //     if (resolution < 1200) {
    //       pos3 = e.targetTouches[0].clientX;
    //       pos4 = e.targetTouches[0].clientY;
    //       document.ontouchend = closeDragElement;
    //       document.ontouchmove = elementDrag;
    //     } else {
    //       // get the mouse cursor position at startup:
    //       pos3 = e.clientX;
    //       pos4 = e.clientY;
    //       document.onmouseup = closeDragElement;
    //       // call a function whenever the cursor moves:
    //       document.onmousemove = elementDrag;
    //     }

    //   }

    //   function elementDrag(e) {
    //     e = e || window.event;
    //     e.preventDefault();
    //     // calculate the new cursor position:
    //     if (resolution < 1200) {
    //       // calculate the new cursor position:
    //       pos1 = pos3 - e.targetTouches[0].clientX;
    //       pos2 = pos4 - e.targetTouches[0].clientY;
    //       pos3 = e.targetTouches[0].clientX;
    //       pos4 = e.targetTouches[0].clientY;
    //     } else {
    //       pos1 = pos3 - e.clientX;
    //       pos2 = pos4 - e.clientY;
    //       pos3 = e.clientX;
    //       pos4 = e.clientY;
    //     }
    //     // set the element's new position:
    //     elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
    //     elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    //     elmnt.style.right = "auto";
    //   }

    //   function closeDragElement() {
    //     if (resolution < 1200) {
    //       document.ontouchend = null;
    //       document.ontouchmove = null;
    //     } else {
    //       /* stop moving when mouse button is released:*/
    //       document.onmouseup = null;
    //       document.onmousemove = null;
    //     }
    //   }
    // }

    changeState() {
        this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
    }

    countThumbs(countThumbs) {
        alert(countThumbs);
    }

    autoPlayImage(play): any {
        if (play) {
            setTimeout(() => {
                this.showPreview(1, this.preview.type, this.preview.index);
                this.autoPlayImage(play);
            }, this.delay);
        } else {
            return;
        }
    }

    loadThumbs() {

        this.images = [];
        this.youtubes = [];
        this.htmls = [];
        this.iframes = [];
        this.documents = [];
        this.pdfs = [];
        this.intro = undefined;
        if (!this.companyId) {
            if (this.route.firstChild) {
                this.companyId = this.route.firstChild.snapshot.params.id;
            } else {
                this.companyId = this.route.snapshot.params.id;
            }
        }
        if (this.companyId) {
            this.db.collection('galleries').doc(this.companyId).collection(this.section).ref.get().then(items => {
                if (this.checkIfItems) {
                    if (items.size === 0) {
                        this.noItems = true;
                    } else {
                        this.noItems = false;
                    }
                    this.isNoItems.emit(this.noItems);
                    return;
                }
                if (items.size === 0) {
                    this.noItems = true;
                } else {
                    this.noItems = false;
                }
                this.isNoItems.emit(this.noItems);
                items.forEach(item => {
                    const itm: any = item.data();
                    switch (itm.type) {
                        case 'image/jpeg':
                        case 'image/png':
                        case 'image':
                        case 'svg':
                            const img = itm as GalleryImage;
                            img.thumb = this.filesBaseUrl + encodeURIComponent(img.thumb) + '?alt=media';
                            img.docId = item.id;
                            img.title = itm.path.substring(itm.path.lastIndexOf('_') + 1);
                            img.title = img.title.substring(0, img.title?.indexOf('.'));

                            // if (!this.showThumbs || this.resolution < 1200 && this.unika ) {
                            if (!this.showThumbs || (this.resolution < 1200 || this.type === 'mosaic' || this.type === 'flyprop') && this.unika) {
                                img.thumb = this.filesBaseUrl + encodeURIComponent(img.path) + '?alt=media';
                            }

                            this.images.push(img);
                            break;
                        case 'pdf':
                        case 'word':
                        case 'excel':
                        case 'powerpoint':
                        case 'tif':
                        case 'mdi':
                        case 'zip':
                        case 'plt':
                            const doc = itm as GalleryDocument;
                            doc.thumb = `/assets/img/${doc.type}.png`;
                            doc.title = doc.path.substring(doc.path.lastIndexOf('/') + 1, doc.path.lastIndexOf('.'));
                            doc.title = doc.title.substring(doc.title.lastIndexOf('_') + 1);
                            doc.path = this.filesBaseUrl + encodeURIComponent(doc.path) + '?alt=media';
                            doc.docId = item.id;
                            if (itm.type == 'pdf') {
                                this.pdfs.push(doc);
                            } else {
                                this.documents.push(doc);
                            }
                            break;

                        case 'iframe':
                            const frm = itm as GalleryIframe;
                            frm.docId = item.id;
                            frm.html = `<iframe src='${frm.path}' frameborder='0'></iframe>`;
                            this.iframes.push(frm);
                            break;

                        case 'youtube':
                            if (this.showThumbs) {
                                const ytb = itm as GalleryYoutube;
                                ytb.docId = item.id;
                                this.youtubes.push(ytb);
                                break;
                            } else {
                                const frm = itm as GalleryIframe;
                                frm.docId = item.id;
                                frm.html = `<iframe class='youtube'
                src='https://www.youtube.com/embed/${this.youtubes[this.preview.index].path}'
                frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                allowfullscreen></iframe>`;
                                this.iframes.push(frm);
                                break;
                            }

                        case 'html':
                            const htm = itm as GalleryHtml;
                            if (htm.title == 'intro') {
                                this.intro = htm;
                                this.intro.docId = item.id;
                            } else {
                                htm.docId = item.id;
                                this.htmls.push(htm);
                            }
                            break;
                    }
                });
                if(this.images.length > 0) {
                    this.images = _.orderBy(this.images, [img => Number(img.count)], ['asc']);
                }
                if (this.autoPlay) {
                    if (this.images.length > 0 && (this.resolution > 1200 || !this.unika || this.resizeDrag || this.images[0].type === 'svg')) {
                        this.showPreview(0, 'image', 0, 'first');
                    } else if (this.youtubes.length > 0) {
                        this.showPreview(0, 'youtube', 0);
                    }
                }

            });
        }

    }

    delete(item: GalleryItem) {

        if (!confirm('are you sure you want to delete this item')) {
            return;
        }

        this.db.collection('galleries').doc(this.companyId).collection(this.section).doc(item.docId).delete().then(() => {

            switch (item.type) {
                case 'image':
                case 'image/jpeg':
                case 'image/png':
                    this.images = this.images.filter(itm => {
                        if (itm.docId != item.docId) {
                            return itm;
                        }
                    });

                    if (confirm('do you want to delete the file from the storage too?')) {
                        this.deleteFile(item);
                    }

                    break;

                case 'pdf':
                    this.pdfs = this.pdfs.filter(itm => {
                        if (itm.docId != item.docId) {
                            return itm;
                        }
                    });
                    if (confirm('do you want to delete the file from the storage too?')) {
                        this.deleteFile(item);
                    }
                    break;

                case 'word':
                case 'excel':
                case 'powerpoint':
                case 'tif':
                case 'mdi':
                case 'zip':
                case 'plt':
                    this.documents = this.documents.filter(itm => {
                        if (itm.docId != item.docId) {
                            return itm;
                        }
                    });
                    if (confirm('do you want to delete the file from the storage too?')) {
                        this.deleteFile(item);
                    }
                    break;

                case 'iframe':
                    this.iframes = this.iframes.filter(itm => {
                        if (itm.docId != item.docId) {
                            return itm;
                        }
                    });
                    break;

                case 'youtube':
                    this.youtubes = this.youtubes.filter(itm => {
                        if (itm.docId != item.docId) {
                            return itm;
                        }
                    });
                    break;

                case 'html':
                    this.htmls = this.htmls.filter(itm => {
                        if (itm.docId != item.docId) {
                            return itm;
                        }
                    });
                    break;
            }
        }).catch(function (error) {
            console.error('error deleting: ', error);
        });
    }

    deleteFile(item) {
        item.path = item.path.replace(this.filesBaseUrl, '');
        if (item.path.indexOf('?') > -1) {
            item.path = item.path.substring(0, item.path.indexOf('?'));
        }
        item.path = decodeURIComponent(item.path);

        item.thumb = item.thumb.replace(this.filesBaseUrl, '');
        if (item.thumb.indexOf('?') > -1) {
            item.thumb = item.thumb.substring(0, item.thumb.indexOf('?'));
        }
        item.thumb = decodeURIComponent(item.thumb);

        this.storage.ref(item.path).delete().subscribe();
        this.storage.ref(item.thumb).delete().subscribe();
    }


    showPreviewCount(step) {
        this.showFullScreen();
        if (!this.showThumbs) {
            return;
        }
        this.preview.show = true;
        this.preview.index += step;
        if (this.preview.index < 0) {
            this.preview.showPrevious = false;
            return;
        } else {
            this.preview.showPrevious = true;
        }
        const maxLength = 1;
        if (this.preview.index >= maxLength) {
            this.preview.index = maxLength - 1;
            this.preview.showNext = false;
            if (this.play == true) {
                this.preview.showNext = true;
                this.preview.index = 0;
            } else {
                return;
            }
        } else {
            this.preview.showNext = true;
        }

        if (this.preview.index == 0) {
            this.preview.showPrevious = false;
        }

        if (this.preview.index == maxLength - 1) {
            this.preview.showNext = false;
        }
    }

    showPreview(step, type?, i?, ifFirst?) {
        if (this.route.snapshot) {
            this.projUid = this.route.snapshot.params.idp;
        }
        if (this.projUid) {
            this.dataService.getSpecProject(this.projUid).subscribe(proj => {
                if (proj.length > 0) {
                    this.illustrationOnly = proj[0].illustrationOnly;
                    this.illustrationOnlyNote = proj[0].illustrationOnlyNote;
                }
            })
        }
        this.showFullScreen();
        if (!this.showThumbs) {
            return;
        }

        this.preview.show = true;
        if (this.type === 'mosaic' && ifFirst !== 'first') {
            this.showMosaicPreview = true;
        }
        if (!type) {
            type = this.preview.type;
        } else {
            this.preview.type = type;
        }

        if (step == 0) {
            this.preview.index = i;
        } else {
            this.preview.index += step;
        }
        if (this.preview.index < 0) {
            this.preview.showPrevious = false;
            return;
        } else {
            this.preview.showPrevious = true;
        }

        let maxLength = 1;
        if (type == 'image') {
            maxLength = this.images.length;
        }
        if (type == 'youtube') {
            maxLength = this.youtubes.length;
        }

        if (type == 'pdf') {
            maxLength = this.pdfs.length;
        }

        if (this.preview.index >= maxLength) {
            this.preview.index = maxLength - 1;
            this.preview.showNext = false;
            if (this.play == true) {
                this.preview.showNext = true;
                this.preview.index = 0;
            } else {
                return;
            }
        } else {
            this.preview.showNext = true;
        }

        if (this.preview.index == 0) {
            this.preview.showPrevious = false;
        }

        if (this.preview.index == maxLength - 1) {
            this.preview.showNext = false;
        }

        switch (type) {
            case 'svg':
                this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
                this.preview.path = this.filesBaseUrl + encodeURIComponent(this.images[this.preview.index].path);
                this.urldd = `${this.filesBaseUrl}${encodeURIComponent(this.images[this.preview.index].path)}?alt=media`;
                this.preview.html = `<img src='${this.filesBaseUrl}${encodeURIComponent(this.images[this.preview.index].path)}?alt=media'/>`;
                debugger;
                // if(this.preview.index > 0 && this.play == true) {
                //   this.test = `<img src='${this.filesBaseUrl}${encodeURIComponent(this.images[this.preview.index-1].path)}?alt=media'/>`;
                // } else {
                //   this.test = `<img src='${this.filesBaseUrl}${encodeURIComponent(this.images[this.preview.index+1].path)}?alt=media'/>`;
                // }
                this.preview.title = this.images[this.preview.index].title;

                // this.changeState();
                break;
            case 'image':
                this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
                this.preview.path = this.filesBaseUrl + encodeURIComponent(this.images[this.preview.index].path);
                this.urldd = `${this.filesBaseUrl}${encodeURIComponent(this.images[this.preview.index].path)}?alt=media`;
                this.preview.html = `<img src='${this.filesBaseUrl}${encodeURIComponent(this.images[this.preview.index].path)}?alt=media'/>`;
                // if(this.preview.index > 0 && this.play == true) {
                //   this.test = `<img src='${this.filesBaseUrl}${encodeURIComponent(this.images[this.preview.index-1].path)}?alt=media'/>`;
                // } else {
                //   this.test = `<img src='${this.filesBaseUrl}${encodeURIComponent(this.images[this.preview.index+1].path)}?alt=media'/>`;
                // }
                this.preview.title = this.images[this.preview.index].title;

                // this.changeState();
                break;

            case 'youtube':
                this.preview.html = `<iframe class='youtube'
        src='https://www.youtube.com/embed/${this.youtubes[this.preview.index].path}'
        frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
        allowfullscreen></iframe>`;
                break;

            case 'pdf':
                if (this.ifMobile()) {
                    this.preview.html = `<iframe class='pdf' src='${this.pdfs[this.preview.index].path}'
          frameborder='0' style='-webkit-overflow-scrolling: touch'></iframe>`;
                } else {
                    this.preview.html = `<embed style='display: block;' class='pdf' src='${this.pdfs[this.preview.index].path}'
          frameborder='0' style='-webkit-overflow-scrolling: touch'></embed>`;
                }
                break;

        }
    }

    test: any;

    showFullScreen(): void {
        if (this.fullscreenTrigger !== undefined && this.fullscreenTrigger !== false) {
            const fsDoc = <any>document;
            if (!isFullScreen()) {
                const fsDocElem = <FsDocumentElement>document.documentElement;
                this.fullscreen = true;
                if (fsDocElem.requestFullscreen) {
                    fsDocElem.requestFullscreen();
                } else if (fsDocElem.msRequestFullscreen) {
                    fsDocElem.msRequestFullscreen();
                } else if (fsDocElem.mozRequestFullScreen) {
                    fsDocElem.mozRequestFullScreen();
                } else if (fsDocElem.webkitRequestFullscreen) {
                    fsDocElem.webkitRequestFullscreen();
                }
            }
        }

    }

    closeFullScreen() {
        const fsDoc = <any>document;
        if (fsDoc.exitFullscreen) {
            // fsDoc.exitFullscreen();
            this.fullscreen = false;
        } else if (fsDoc.msExitFullscreen) {
            fsDoc.msExitFullscreen();
            this.fullscreen = false;
        } else if (fsDoc.mozCancelFullScreen) {
            fsDoc.mozCancelFullScreen();
            this.fullscreen = false;
        } else if (fsDoc.webkitExitFullscreen) {
            fsDoc.webkitExitFullscreen();
            this.fullscreen = false;
        }
    }


    closePreview() {

        if (this.type === 'mosaic' && this.screenResolutionDetecting() > 1200) {
            this.showMosaicPreview = false;
        } else {
            this.closeFullScreen();
            this.preview.show = false;
        }
    }

    screenResolutionDetecting() {
        return window.innerWidth;
    }

    changeImageSize(sign) {
        const imageHolder = document.getElementsByClassName('preview-img');
        const imagePreview = imageHolder[0].getElementsByTagName('img');
        imagePreview[0].style.maxWidth = 'inherit';
        imagePreview[0].style.maxHeight = 'inherit';
        // let imagePreviewWidth = imagePreview[0].width;
        // let imagePreviewHeight = imagePreview[0].height;
        // console.log(imagePreviewWidth, imagePreviewHeight);
        if (imagePreview[0].style.width !== '') {
            let percents: any = parseInt(imagePreview[0].style.width);
            if (sign === 'plus') {
                percents = percents + 5 + '%'
            } else {
                percents = percents - 5 + '%'
            }
            imagePreview[0].style.width = percents;
        } else {
            if (sign === 'plus') {
                imagePreview[0].style.width = '105%';
            } else {
                imagePreview[0].style.width = '95%';
            }
        }
        imagePreview[0].style.height = 'auto';

    }

    onMouseWheel(event) {
        console.log(event.target);
    }

    ifMobile() {
        if (this.screenResolutionDetecting() < 1200) {
            return -1;
        }
    }

    download(item) {

        const url = this.filesBaseUrl + encodeURIComponent(item.path) + '?alt=media';
        const img: any = document.getElementById('imgDownload');
        img.src = url;

        setTimeout(() => {

            const data = this.getBase64Image(url)

            const tag = document.createElement('a');
            tag.href = data;
            tag.download = 'image.png';
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);

        }, 1000);

    }


    getBase64Image(url) {
        const img: any = document.getElementById('imgDownload');
        // img.src=url;

        // Create an empty canvas element
        const canvas: any = document.getElementById('canvasDownload');
        canvas.width = img.width;
        canvas.height = img.height;

        // Copy the image contents to the canvas
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        // Get the data-URL formatted image
        // Firefox supports PNG and JPEG. You could check img.src to
        // guess the original format, but be aware the using 'image/jpg'
        // will re-encode the image.
        const dataURL = canvas.toDataURL('image/png');

        return dataURL;

    }
}



